<template>
  <v-data-table
    show-expand
    item-key="id"
    :headers="headers"
    :items="shortcuts"
    :single-expand="true"
    :expanded.sync="expanded"
    height="640"
  >
    <template v-slot:[`item.marked`]="{ item }">
      <v-icon v-if="item.marked" small color="orange">mdi-star</v-icon>
      <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;</span>
    </template>
    <template v-slot:[`item.stime`]="{ item }">
      {{ dateFormat(new Date(item.stime), 'YY-MM-DD hh:mm') }}
    </template>
    <template v-slot:[`item.rain`]="{ item }">
      {{ item.rain | rainLabel }}
    </template>
    <template v-slot:[`item.wind1`]="{ item }">
      {{ (item.wind1 / 10).toFixed(1) }}
    </template>
    <template v-slot:[`item.wind2`]="{ item }">
      {{ (item.wind2 / 10).toFixed(1) }}
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <shortcut-expand :shortcut-id="item.id" />
      </td>
    </template>
  </v-data-table>
</template>
<script>
import RainLevelNameMixin from './RainLevelNameMixin'

import ShortcutExpand from './HistoryDetailTableExpand.vue'

export default {
  mixins: [RainLevelNameMixin],
  components: { ShortcutExpand },
  props: {
    shortcuts: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },
  data: () => ({
    expanded: [],
    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'marked',
        width: 45,
      },
      {
        text: '时间',
        align: 'start',
        sortable: false,
        value: 'stime',
        width: 150,
      },
      {
        text: '雨量',
        align: 'center',
        sortable: false,
        value: 'rain',
        width: 100,
      },
      {
        text: '东侧风速m/s',
        align: 'center',
        sortable: false,
        value: 'wind1',
        width: 100,
      },
      {
        text: '西侧风速m/s',
        align: 'center',
        sortable: false,
        value: 'wind2',
        width: 100,
      },
      {
        text: '备注',
        align: 'start',
        sortable: false,
        value: 'memo',
      },
      { text: '', value: 'data-table-expand' },
    ],
  }),
}
</script>



// WEBPACK FOOTER //
// src/components/history/HistoryDetailTable.vue